:host {
  display: block;
  max-width: 100%;
  background: var(--white-layout-301-level-0-elevation);
}

gz-banner::part(bitdefender-logo) {
  width: 400px;
  height: 400px;
  top: 32px;
}

gz-banner::part(banner-wrapper) {
  width: 900px;
}

#sso-infobox-wrapper {
  padding-left: 36px;
  padding-top: 30px;

  #sso-disabled {
    padding: 0;
  }
}

.wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 30px;
  padding-left: 36px;
  height: auto;

  gz-icon[class*='mdr-logo'] {
    display: flex;
    align-items: flex-start;
    justify-content: normal;

    svg {
      width: 316px;
      height: 84px;
    }
  }

  #mdr-text {
    text-align: left;
    width: 400px;
    margin-top: var(--spacer);
    margin-bottom: var(--spacer);
  }

  #mdr-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: calc(var(--spacer) * 0.75);
  }

  #mdr-license-info {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacer) * 0.75);
  }

  #mdr-warranty-info {
    display: flex;
    flex-direction: column;
    gap: calc(var(--spacer) * 0.75);
    padding-top: 32px;
  }

  #open-console-button {
    align-self: flex-start;
  }

  #license-expiration-info {
    padding: 0;
  }
}
